import { defineComponent as _defineComponent } from 'vue'
import { computed } from '@nuxtjs/composition-api';
import ProductFeatures from '~/components/sections/productSection/ProductFeatures.vue';
import ProductUserHelp from '~/components/sections/productSection/ProductUserHelp.vue';
import ProductSoftware from '~/components/sections/productSection/ProductSoftware.vue';

interface Props {
  product?: any;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductDetails',
  props: {
    product: { default: () => ({}) }
  },
  setup(__props: any) {

const props = __props as { product: any };



const isShowUserHelp = computed(
  () =>
    props.product.documents.manuals?.length > 0 ||
    props.product.documents.videos?.length > 0 ||
    props.product.faqs?.length > 0,
);

const software = computed(() =>
  props.product?.content.find(
    (item: { type: string }) => item.type === 'software-documents',
  ),
);

return { __sfc: true,props, isShowUserHelp, software, ProductFeatures, ProductUserHelp, ProductSoftware }
}

})